<template>
  <el-skeleton
    animated
    class="monitoring-skeleton"
  >
    <template slot="template">
      <el-skeleton-item :variant="variant" />
    </template>
  </el-skeleton>
</template>

<script>
  export default {
    name: 'MonitoringSkeleton',
    props: {
      // el-skeleton-item variant: text | p | h1 | h3 | h5 | caption | button
      variant: {
        type: String,
        default: 'text',
      },
    },
  };
</script>

<style lang="scss" scoped>
  // Element's skeleton grey (#f2f2f2) glares on the dashboard's dark panels, so
  // the bar and its shimmer are retinted. The animation itself is inherited.
  .monitoring-skeleton {
    ::v-deep .el-skeleton__item {
      background: rgba(#fff, 0.07);
    }

    ::v-deep .el-skeleton.is-animated .el-skeleton__item {
      background: linear-gradient(
        90deg,
        rgba(#fff, 0.07) 25%,
        rgba(#fff, 0.14) 37%,
        rgba(#fff, 0.07) 63%
      );
      background-size: 400% 100%;
    }
  }
</style>
